import { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
    const [typeMode, setTypeMode] = useState(1);
    const [worksite, setWorksite] = useState(null);
    const [descWorksite, setDescWorksite] = useState(null);
    const [showBarDesc, setShowBarDesc] = useState(false);
    const [showChangeMode, setShowChangeMode] = useState({ typeMode: null, show: false});

    return (
        <AppContext.Provider value={{ typeMode, setTypeMode, worksite, setWorksite, descWorksite, setDescWorksite, showBarDesc, setShowBarDesc, showChangeMode, setShowChangeMode }}>
            {children}
        </AppContext.Provider>
    );
};